/**
 * Created by jonas on 2019-08-21.
 */
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {Linear, TimelineLite, TweenLite} from "gsap";
import {IWinRatioConfig} from "@nolimitcity/slot-game/bin/core/winpresentation/WinRatio";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {WinterHoardLayerConfig} from "../config/WinterHoardLayerConfig";
import {IBuffaloWinRatioConfig} from "../WinterHoardGameConfig";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {SoundPlayer} from "../sound/SoundPlayer";

export class WinTextView extends BaseView {
    private _winText:PIXI.spine.Spine;
    private _winTextContainer:PIXI.Container;
    private _layer:ScalableLayer;
    private _currentSound:string ="";

    constructor() {
        super();
        this._layer = StageManager.getLayer(WinterHoardLayerConfig.BIG_WIN.name);
    }


    protected initAnimations():void {
        this._winText = new PIXI.spine.Spine(GameResources.getSpineAsset("bigWinText"));
        this._winText.position.set(0, 0);
        this._winText.renderable = false;

        this._winTextContainer = new PIXI.Container();
        this._winTextContainer.position.set(360, 200);

        this._winTextContainer.addChild(this._winText);
        this.addChild(this._winTextContainer);
    }


    public getStartAnimation(config:IBuffaloWinRatioConfig, level:number):TimelineLite{
        const tl: TimelineLite = new TimelineLite();
        tl.add(() => {
            this._layer.addChild(this);
        });
        tl.add(()=>{
            this.playWinSound(config);
            if(level===0) {
                this._winText.state.setAnimation(0, `l1_start`, false);
                this._winText.renderable = true;
                this._winTextContainer.alpha = 1;
            }else{
                this._winText.state.setAnimation(0, `l${level}_to_l${level+1}_switch`, false)
            }
        }, 0.1);
        //New text show
        tl.add(()=>{
            this._winText.state.setAnimation(0, `l${level+1}_loop`, true)
        },0.76);
        return tl;
    }

    public getEndAnimation(config:IWinRatioConfig, level:number):TimelineLite{
        const tl:TimelineLite = new TimelineLite();
        tl.add(()=>{
            if(this._winText.state.hasAnimation(`l${level +1}_end`)) {
                this._winText.state.setAnimation(0, `l${level + 1}_end`, false);
            }
        });
        return tl;
    }

    public abort(config:IBuffaloWinRatioConfig, level:number):TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        if(config.text == undefined || config.text == "") {
            return tl;
        }
        tl.add(() => {
            this.playWinSound(config);
            tl.add(()=>{this._winText.state.setAnimation(0, `l${level}_end`, false)});
            this._layer.addChild(this);
            this._winText.renderable = true;
            this._winTextContainer.alpha = 1;
        }, 0.001);
        return tl;
    }

    public end(config:IBuffaloWinRatioConfig, displayDuration:number, fadeOutDuration:number):TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        tl.add(() => {
            this._currentSound = "";
            this.fadeAndRemove(fadeOutDuration);
        }, displayDuration);
        tl.add(() => this.cleanup());
        return tl;
    }

    private fadeAndRemove(duration:number) {
        const tl:TimelineLite = new TimelineLite();

        tl.add([
            new TweenLite(this._winTextContainer, duration, {alpha : 0, ease : Linear.easeNone})
        ]);
        tl.add(() => {
            this._layer.removeChild(this);
        });
        return tl;
    }

    private cleanup() {
        this._winText.renderable = false;
        this._winText.state.setAnimation(0, `l1_start`, false);
    }


    private playWinSound(config:IBuffaloWinRatioConfig){
        let newSound:string = "";
        if (config.sound){
            newSound = config.sound;
        }

        if (this._currentSound != newSound){
            if (this._currentSound != ""){
                SoundPlayer.stopEffect(this._currentSound);
            }
            SoundPlayer.playEffect(newSound,0);
            this._currentSound = newSound;
        }
    }
}